import "./App.css";
import { TablePokeApp } from "./components/TablePokeApp";

function App() {
  return (
    <div className="App">
      <TablePokeApp />
    </div>
  );
}

export default App;
